import { render, staticRenderFns } from "./SCRAMReportA.vue?vue&type=template&id=76d1a495"
import script from "./SCRAMReportA.vue?vue&type=script&lang=js"
export * from "./SCRAMReportA.vue?vue&type=script&lang=js"
import style0 from "./SCRAMReportA.vue?vue&type=style&index=0&id=76d1a495&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports